import React from 'react'
import './circularLoader.css';

const CircularLoader = () => {
  return (
    <div className="circular-loader center"><span></span></div>
  )
}

export default CircularLoader